import { useRef, useCallback } from 'react';
import { setRef } from './setRef';

export const useDefaultRef = (refFromProps, initialValue = null) => {
  const tempRef = useRef(initialValue);

  const setRefValue = useCallback(
    value => {
      setRef(tempRef, value);
      setRef(refFromProps, value);
    },
    [tempRef, refFromProps]
  );

  return [tempRef, setRefValue];
};
